import {Blurer} from './Blurer';
import {Container} from './Container';

export const Modal = {
    Blurer,
    Container,
};
